import Alpine from "alpinejs";
import { SingleCollapse } from "../utilities/Collapse/SingleCollapse.js";
import { Collapse } from "../utilities/Collapse/Collapse";

window.safeStartSpan({
    name: "jsFaq file registered",
    op: "alpine.init",
});

document.addEventListener("alpine:init", () => {
    Alpine.data("collapse", () => new Collapse());
    Alpine.data("singleCollapse", () => new SingleCollapse());
});
